import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { shaxmatkaConstants } from '..';

export const useFlatGroupAction = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: {
      actionType: 'M2_PRICE';
      filter?: any;
      flatIds?: number[];
      ignoredFlatIds?: number[];
      percentage?: number;
      type?: 'REPAIRED' | 'WITHOUT_REPAIR' | 'ALL' | (string & {});
    }) => {
      const res = await $api.post('/v1/flat/group-action', {
        ...data,
        flatIds: data?.flatIds?.length === 0 ? null : data?.flatIds,
        ignoredFlatIds: data?.ignoredFlatIds?.length === 0 ? null : data?.ignoredFlatIds
      });

      return res?.data?.data;
    },
    {
      onSuccess(data, variables) {
        qc.invalidateQueries([shaxmatkaConstants.queryKeys.FLAT_FILTER_TABLE, variables?.filter]);
      }
    }
  );
};
